package ir.site.zero1plus.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.extendedBy
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import ir.site.zero1plus.helper.colorModeDetect
import ir.site.zero1plus.model.NavBarMenu
import ir.site.zero1plus.theme.*
import ir.site.zero1plus.theme.PrimaryLight
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text


val FooterStyle = SmoothColorStyle.extendedBy {
    base {
        Modifier.fillMaxWidth()
            .boxShadow(
                spreadRadius = 1.px,
                color = colorModeDetect(
                    PrimaryDark.copyf(alpha = 0.08f) ,
                    PrimaryLight.copyf(alpha = 0.25f)
                )
            )
    }
}

val FooterLinkStyle = CssStyle {
    base {
        Modifier
            .color(
                colorModeDetect(
                    darkMode = TextSecondaryDark,
                    lightMode = TextSecondaryLight
                )
            )
            .textDecorationLine(TextDecorationLine.None)
            .fontSize(14.px)
    }
}

val SocialLinkStyle = SmoothColorStyle.extendedBy {
    base {
        Modifier
            .textDecorationLine(TextDecorationLine.None)
            .color(
                colorModeDetect(
                    darkMode = LinkDark,
                    lightMode = LinkLight
                )
            )
            .transition(Transition.of(property = "color", duration = 300.ms))
    }
    hover {
        Modifier.color(
            colorModeDetect(
                darkMode = LinkHoverColorDark,
                lightMode = LinkHoverColorLight
            )
        )
    }
}


val SocialLinkItemStyle = SmoothColorStyle.extendedBy {
    cssRule(" > div") {
        Modifier
            .size(38.px)
            .backgroundColor(
                colorModeDetect(
                    SurfaceDark,
                    SurfaceLight
                )
            )
            .borderRadius(50.percent)
    }

    cssRule(" > span") {
        Modifier
            .color(
                colorModeDetect(
                    darkMode = TextSecondaryDark,
                    lightMode = TextSecondaryLight
                )
            )
            .fontSize(14.px)
            .fontWeight(FontWeight.Medium)
    }

}

@Composable
fun FooterSection() {
    Footer(
        attrs = FooterStyle.toAttrs()
    ) {
        Box(
            modifier = Modifier.fillMaxWidth()
                .padding(topBottom = 60.px),
            contentAlignment = Alignment.Center
        ) {
            Column(
                Modifier.fillMaxWidth(80.percent),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {

                    NavigationMenuList()

                    ContactDetails()
                }
                Span(
                    attrs = Modifier.margin(top = 50.px).toAttrs()
                ) {
                    Text("ساخته شده توسط محمد حسین مظلوم زاده با ")
                    Link("https://kotlinlang.org/", "Kotlin ")
                    Text("و ")
                    Link("https://kobweb.varabyte.com/", "kobweb")
                }
            }
        }
    }
}


@Composable
fun NavigationMenuList() {
    Column {
        SpanText(
            text = "برو به",
            modifier = Modifier
                .fontSize(clamp(18.px, 5.vw, 20.px))
                .fontWeight(FontWeight.Bold)
                .margin(top = 16.px, bottom = 26.px),
        )
        Column(
            verticalArrangement = Arrangement.spacedBy(26.px),
        ) {
            NavBarMenu.entries.forEach {
                Link(
                    modifier = FooterLinkStyle.toModifier(),
                    path = it.path
                ) {
                    Text(it.title)
                }
            }
        }
    }
}


@Composable
fun ContactDetails() {
    Column(
    ) {
        SpanText(
            text = "راه های ارتباط",
            modifier = Modifier
                .fontSize(clamp(18.px, 5.vw, 20.px))
                .fontWeight(FontWeight.Bold)
                .margin(topBottom = 16.px),
        )
        Column(
            verticalArrangement = Arrangement.spacedBy(8.px),
        ) {
            SocialItem(
                path = "https://www.instagram.com/mohammadhosseinmz/",
                title = "پیج اینستاگرام"
            ) {
                FaInstagram(
                    modifier = Modifier,
                    size = IconSize.LG,
                )
            }

            SocialItem(
                path = "https://t.me/HoSsEiNMhMz",
                title = "تلگرام"
            ) {
                FaTelegram(
                    modifier = Modifier,
                    size = IconSize.LG,
                )
            }

            SocialItem(
                path = "",
                title = "اهواز ، پردیس  ، گلفام"
            ) {
                FaLocationDot(
                    modifier = Modifier,
                    size = IconSize.LG,
                )
            }
            SocialItem(
                path = "",
                title = "hossein.mz1395@gmail.com"
            ) {
                FaEnvelope(
                    modifier = Modifier,
                    size = IconSize.LG,
                    style = IconStyle.FILLED
                )
            }
        }
    }
}

@Composable
fun SocialItem(
    path: String,
    title: String,
    icon: @Composable () -> Unit
) {
    Link(
        modifier = SocialLinkStyle.toModifier(),
        path = path
    ) {
        Row(
            modifier = SocialLinkItemStyle.toModifier(),
            horizontalArrangement = Arrangement.spacedBy(10.px),
            verticalAlignment = Alignment.CenterVertically
        ) {

            Box(
                contentAlignment = Alignment.Center
            ) {
                icon()
            }
            SpanText(title)
        }

    }

}




